import { useSyncExternalStore } from 'react';

export function useScrollTop() {
  const getScrollPosition = () => {
    if (typeof window === 'undefined') return 0;
    return window.scrollY || document.documentElement.scrollTop;
  };

  const subscribe = (callback: () => void) => {
    window.addEventListener('scroll', callback, { passive: true });
    return () => {
      window.removeEventListener('scroll', callback);
    };
  };

  // Use useSyncExternalStore to subscribe to scroll position
  return useSyncExternalStore(subscribe, getScrollPosition, () => 0);
}
